import $ from 'domtastic';
import { Starred } from '../components/Starred';
import starredItem from '../components/markup/starredItem';

const starred = {
  init() {
    this.cacheDom();
    if (!this.$list[0]) return;

    this.render();
  },

  cacheDom() {
    this.$list = $('.js-starred-list');
    this.$remove = $('.js-starred-remove');
    this.$contactsContainer = $('.js-starred-contacts-container');
  },

  createDom() {
    const elements = [];
    Object.values(Starred.getPreviousStarred()).forEach((object) => {
      const element = starredItem.create(object);
      elements.push(element);
    });

    return elements;
  },

  bindEvents() {
    this.$remove.off().on('click', (event) => {
      event.preventDefault();
      const $removeInvoker = $(event.currentTarget);
      this.removeItem($removeInvoker);
      this.animateItem($removeInvoker);
    });
  },

  removeItem($removeInvoker) {
    const store = Starred.getPreviousStarred();
    const slug = $removeInvoker.data('slug').trim();
    const newStore = Starred.removeFromStore(store, null, slug);
    Starred.onUpdate(null, Object.keys(newStore).length, null);
    Starred.setStarred(newStore);
    this.showEmpty(Object.keys(newStore).length < 1);
  },

  animateItem($removeInvoker) {
    const $item = $removeInvoker.closest('.js-starred-item');
    if (!$item[0]) return;
    $item.addClass('-remove');
    $item.off().on('transitionend', () => {
      $item.addClass('-hidden');
      $item.remove();
    });
  },

  showEmpty(isEmpty) {
    if (!isEmpty) return;
    this.$list.html('<span class="starred__error">Du har inte stjärnmarkerat några produkter ännu.</span>');
    this.$contactsContainer.css('display', 'none');
  },

  render() {
    const elements = this.createDom();
    elements.forEach(element => this.$list.append(element));
    this.showEmpty(!elements.length || (elements.length && elements.length < 1));
    this.cacheDom();
    this.bindEvents();
  },
};

export default starred.init();



// WEBPACK FOOTER //
// ./pages/starred.js